'use client';

import { useEffect } from 'react';
import { sendGAEvent } from '@next/third-parties/google';

interface ArticleAnalyticsProps {
    post: {
        id: string | number;
        title: string;
        category_name?: string;
        author_name?: string;
        [key: string]: any;
    };
}

export default function ArticleAnalytics({ post }: ArticleAnalyticsProps) {
    useEffect(() => {
        // Delay slightly to ensure GA is loaded/ready, though usually not needed with next/third-parties
        sendGAEvent('event', 'view_item', {
            currency: 'ZAR', // Optional, good for e-comm context
            value: 0,
            items: [
                {
                    item_id: post.id.toString(),
                    item_name: post.title,
                    item_category: post.category_name || 'General',
                    item_brand: post.author_name || 'CarSite.co.za',
                }
            ]
        });
    }, [post]);

    return null;
}
